import { Box, Link, Rating } from "@mui/material";

import { TimeSince } from "components/DateTime/TimeSince";
import { FlexBox } from "components/Wrappers/FlexBox/FlexBox";
import { TimeLeft } from "components/DateTime/TimeLeft";
import { ContextMenu } from "components/Menu/ContextMenu";
import { CURRENCY_SYMBOLS } from "constants/currencyConstants";

// Define the column configuration here
export const enquiryListColumnsL = ({
  handleRowClick,
  handleLink,
  handleEdit,
  handleChangeStatus,
  handleTaskButtonClick,
  curUserId,
}) => [
  {
    accessorKey: "clientName",
    header: "Name",
    cell: ({ row }) => (
      <FlexBox justifyContent="space-between">
        <Link
          href="#"
          onClick={() => handleRowClick(row.original)}
          color="textPrimary"
        >
          {row.original.docCode}
          <br />
          {row.original.clientName}
        </Link>
      </FlexBox>
    ),
  },
  { accessorKey: "clientType", header: "Type" },
  {
    accessorKey: "weightage",
    header: "Weightage",
    cell: ({ row }) => (
      <Rating value={row.original.weightage} size="small" readOnly />
    ),
  },
  { accessorKey: "clientContactNo", header: "Contact No" },
  { accessorKey: "clientEmail", header: "Email" },
  {
    accessorKey: "deliveryDate",
    header: "Delivery Date",
    cell: ({ row }) => (
      <TimeLeft
        targetDate={row.original.deliveryDate}
        variant="data"
        fontSize={12}
      />
    ),
  },
  {
    accessorKey: "targetConversionDate",
    header: "Target Conversion Date",
    cell: ({ row }) => (
      <TimeLeft
        targetDate={row.original.targetConversionDate}
        variant="data"
        fontSize={12}
      />
    ),
  },
  {
    accessorKey: "budget",
    header: "Budget",
    cell: ({ row }) => (
      <FlexBox justifyContent="space-between">
        <div>{row.original.currency}</div>
        <div>
          {(CURRENCY_SYMBOLS?.[row.original.currency] || "") +
            " " +
            row.original.budget}
        </div>
      </FlexBox>
    ),
  },
  {
    accessorKey: "createdBy",
    header: "BDC",
    cell: ({ row }) => (
      <Box whiteSpace={"pre-line"}>
        {row.original.createdBy}
        <br />
        <TimeSince startDate={row.original.createdOn} />
      </Box>
    ),
  },
  { accessorKey: "clientCity", header: "City" },
  {
    accessorKey: "status",
    header: "Registered",
    cell: ({ row }) => (
      <>{row.original.status === "REGISTER_PROJECT" ? "Yes" : "No"}</>
    ),
  },
  {
    accessorKey: "action",
    header: "Action",
    cell: ({ row }) => (
      <ContextMenu
        handleLinkClick={() => handleLink(row.original.link)}
        linkLabel="Link"
        handleMiscAction1={
          curUserId === row.original.createdById
            ? () => handleChangeStatus("REGISTER_PROJECT", row.original.id)
            : null
        }
        misc1Label="Register Project"
        handleEditAction={
          curUserId === row.original.createdById
            ? () => handleEdit(row.original)
            : null
        }
        editLabel="Edit"
        handleTaskAction={() => handleTaskButtonClick(row.original)}
        taskLabel="Create Task"
      />
    ),
  },
];
